/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Assembling, 1 = Assembled, 2 = Deployed, 3 = Rejected
 */
export enum ProducedDeviceStatus {
    Assembling = 0,
    Assembled = 1,
    Deployed = 2,
    Rejected = 3
}

